import { render, staticRenderFns } from "./knowledgeBaseSection.vue?vue&type=template&id=317de08b&"
import script from "./knowledgeBaseSection.vue?vue&type=script&lang=js&"
export * from "./knowledgeBaseSection.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeBaseSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports